exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".base {\n  display: inline-table; }\n\n.base, .base * {\n  font-family: inherit;\n  color: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  text-transform: inherit;\n  text-decoration: inherit; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/price-resize/price-resize.component.scss
// module id = ../../../../../src/app/components/common/price-resize/price-resize.component.scss
// module chunks = 0